import { InventoryCity } from './inventoryCity';

export class InventoryArea {
    id: string;
    name: string;
    city: InventoryCity = new InventoryCity();
}